var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHudbaylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 428",
    width: 1485,
    height: 311,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,52)",
    d: "m0 0h161l25 2 24 5 21 7 17 8 15 10 10 8 15 15 11 15 10 19 6 16 5 21 2 15 1 26-2 25-4 20-6 18-8 17-7 11-10 13-14 14-15 11-16 9-19 8-22 6-19 3-10 1h-281l3-2 18-6 19-9 12-8 10-8 16-16 11-16 8-16 6-16 4-16 2-15zm110 91v142h45l14-2 13-5 11-7 9-10 6-10 5-16 2-15v-13l-3-19-6-15-7-10-9-9-16-8-12-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(54,52)",
    d: "m0 0h109l1 1v113h104v-113l1-1h110l1 189 2 20 5 21 6 16 9 17 9 12 9 10 11 10 15 10 21 10 22 7v1h-220l-1-1v-116l-9-1h-95v118h-110z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1041,52)",
    d: "m0 0h173l25 2 20 4 15 5 14 7 13 10 8 9 8 14 5 16 2 16v12l-3 17-6 14-8 11-8 8-14 9 21 8 15 9 12 11 9 14 5 14 2 10v27l-4 17-8 16-9 11-9 8-13 8-16 7-13 4-23 4-10 1h-203zm108 76v46h43l10-3 6-4 5-10v-11l-3-8-8-7-9-3zm0 122v49h58l13-2 7-4 6-7 2-6v-11l-3-8-9-8-12-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1470,52)",
    d: "m0 0h124l3 5 17 47 18 49 42 115 18 49 21 57v1h-107l-15-43-1-6h-116l-2 10-13 38-1 1h-106l3-10 19-52 18-49 23-63 18-49 23-63 13-35zm62 104-14 41-17 50v3h63l-3-11-28-83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1649,52)",
    d: "m0 0h120l12 22 20 39 20 38 2 1 2-6 14-27 12-22 10-20 10-19 4-6h120l-6 11-17 28-42 69-16 26-17 28-14 23-7 11-1 34v92l-1 1h-105l-1-126-31-51-16-26-12-20-16-26-34-56-10-16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,52)",
    d: "m0 0h105l1 5v172l-2 16-4 12-6 10-8 8-12 6-13 3h-17l-16-4-11-7-7-8-6-12-3-11-1-9z",
    fill: "#EF3424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHudbaylogo);
export default __webpack_public_path__ + "static/media/HUDBAYLOGO.cd6f52a8f2a4ccaf680b7bae4e283ed1.svg";
export { ForwardRef as ReactComponent };